import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { OperationCard } from '../../../../operation-card';
import {
  RegisterIcon,
  LinkIcon,
  UnlinkIcon,
} from '../../../../operation-card/operation-icons';
import styles from './step-operation.module.css';

import type { OperationType } from '../../terminal-operation-drawer.type';
import type { StepOperationProps } from './step-operation.type';

interface OperationCardConfig {
  type: OperationType;
  icon: ReactNode;
  labelKey: string;
  descriptionKey: string;
}

const OPERATION_CARDS: OperationCardConfig[] = [
  {
    type: 'REGISTER',
    icon: <RegisterIcon />,
    labelKey: 'backoffice.terminalsDrawerOperationTitleREGISTER',
    descriptionKey: 'backoffice.terminalsDrawerOperationDescriptionREGISTER',
  },
  {
    type: 'LINK',
    icon: <LinkIcon />,
    labelKey: 'backoffice.terminalsDrawerOperationTitleLINK',
    descriptionKey: 'backoffice.terminalsDrawerOperationDescriptionLINK',
  },
  {
    type: 'UNLINK',
    icon: <UnlinkIcon />,
    labelKey: 'backoffice.terminalsDrawerOperationTitleUNLINK',
    descriptionKey: 'backoffice.terminalsDrawerOperationDescriptionUNLINK',
  },
];

export const StepOperation = ({ selectedOperation, onSelectOperation }: StepOperationProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>
          {t('backoffice.terminalsDrawerStepOperationTitle')}
        </span>
        <span className={styles.description}>
          {t('backoffice.terminalsDrawerStepOperationDescription')}
        </span>
      </div>

      <div className={styles.list}>
        {OPERATION_CARDS.map(({ type, icon, labelKey, descriptionKey }) => (
          <OperationCard
            key={type}
            icon={icon}
            labelKey={labelKey}
            descriptionKey={descriptionKey}
            selected={selectedOperation === type}
            onClick={() => onSelectOperation(type)}
          />
        ))}
      </div>
    </div>
  );
};
